// import React from 'react'

import { learningObjectivesIntro, activitiesListIntro, standardActivities, initialPost, standardActivitiesClosing, closing, estimated } from './AL00000Sprint00'
import { oreillyPlaylistSE, HTMLW3C, CSSW3C, JavaScriptW3C, RegularExpressionsW3C, internalLink } from '../DataAndAPIs/Links'

import { assignmentPortfolioLink } from '../Activities/WebAssignmentPortfolio'
import { azureWebsiteLink } from '../Activities/AzureWebsite'
import { webResumeLink } from '../Activities/WebResume'
import { webDiceRollerLink } from '../Activities/WebDiceRoller'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { lionsTigersAndBearsLink } from '../Activities/LionsTigerAndBears'
import { gitCommands } from '../DataAndAPIs/Links'

const foxChapter2Lecture = () => internalLink('lecture', '/activity/fox-chapter-02')
const foxChapter6Lecture = () => { return internalLink('lecture', '/activity/fox-chapter-06')}

export const al44000Sprint02 = () => {
	const sprint = 2
	return ( <div>
		<h5>Sprint 2: {getModuleDescription(sprint-1)}</h5>
		
		<p><em>Welcome to sprint 2.</em> We covered a lot of material in sprint 1. However, we didn't get a chance to write 
		much code. This sprint get your text editors out. We are going to start practicing some of the concepts we learned.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Write simple HTML, CSS, Javascript, and Node.js applications and install them to Azure</li>
			<li>Understand has SaaS applications are developed in JavaScript using AJAX and JSON</li>
			<li>Comfortably be able to utilize single-developer workflow with Git and GitHub</li>
			<li>Understand simple Ruby programs using basic control structures and data structures</li>
		</ul>

		{list44000Sprint02(sprint)}
		{closing()}
	</div> )
}

export const list44000Sprint02 = (sprint) => {
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, lionsTigersAndBearsLink())}
			<li>Read “Engineering Software as a Service” Chapter 2 and review our associated {foxChapter2Lecture()}{estimated('1 hour')}</li>
			<li>Implement {assignmentPortfolioLink()} using an {azureWebsiteLink()}{estimated('2 hours')}</li>
			<li>Within {oreillyPlaylistSE()} scan “Learning Web App Development” Preface through Chapter 4</li>
			<li>Implement your {webResumeLink()} Requirement 1 and 2 while completing the W3Schools {HTMLW3C()} and {' '}
				{CSSW3C()} tutorials{estimated('2 hours')}</li>
			{initialPost(sprint)}
			<li>Study and consistently utilize the {gitCommands()} and patterns used by professional development teams</li>
			<li>Complete {webDiceRollerLink()}</li>
			<li>Read “Engineering Software as a Service” chapter 6 plus A.6 and A.7 and review our chapter 6 {foxChapter6Lecture()}</li>
			<li>Scan {JavaScriptW3C()} tutorial up to {RegularExpressionsW3C()}</li>
			{standardActivitiesClosing(sprint, lionsTigersAndBearsLink(), '2 hours')}
		</ol>
	</div> )
}

// Certified for FA26 on September 23, 2026

